module.exports = __webpack_public_path__ + "static/media/backgroundOnBlur.4c22f38b.png";